import {
  Backtop, Breadcrumb,
  BreadcrumbItem, Button, Card, Carousel, CarouselItem, Checkbox, Col, Dialog, Dropdown, DropdownItem, DropdownMenu, Form,
  FormItem, Icon, Image, Input, RadioButton, RadioGroup, Row
} from 'element-ui';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import ementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/icon';
import '@/permission';
import VideoPlayer from 'vue-video-player';
import './css/common.css';
import store from './store';
import './tailwind.css';
require('vue-video-player/node_modules/video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');

Vue.use(Backtop)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Input)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(CarouselItem)
Vue.use(Icon)
// Vue.use(ementUI);
Vue.use(VideoPlayer);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
